<template>
  <div class="menu-item-r">
    <div class="v-exhibits-detail-page">
      <div class="v-nav-wrap bl-container" v-if="subjectType == 'ACTOR'">
        <el-button class="el-button--primary-empty" type="primary" size="small" @click="$router.push('/my-exhibit-list')">{{
          $t('My Exhibit List')
        }}</el-button>
        <el-button class="el-button--primary-empty" type="primary" size="small" @click="productEditor">{{
          $t('editor')
        }}</el-button>
        <el-button class="el-button--primary-empty" type="primary" size="small" @click="productDel">{{
          $t('del')
        }}</el-button>
      </div>
      <div class="v-exhibits-header">
        <v-exhibits-detail 
          @callback="callback" 
          class="v-detail" 
          className="actor-v-detail"
          identity="ACTOR"
          :slides="5" 
          :vData="exhibitInfo">
          <template v-slot:actor><span></span></template>
        </v-exhibits-detail>
      </div>
      <div class="p-l-15">
        <div class="v-exhibits-content">
          <div class="v-exhibits-base-info">
            <div class="baseInfo-title">{{$t('baseInfo')}}</div>
            <el-row :gutter="30">
              <template v-if="exhibitInfo && exhibitInfo.details">
                <template v-for="item in exhibitInfo.details">
                  <el-col :span="12" class="detail-questionTag" :key="item.keyword" v-if="item.showValue.content && (['productName','productIntro', 'productEnIntro'].indexOf(item.keyword) == -1)">
                    <span>{{ item.showValue.title }}：</span>
                    <label class='theme-label'>
                      <a :href="item.showValue.content" v-if="item.keyword == 'webUrl'" target="view_window">{{ $t('finds.enterDetail') }}</a>
                      <template v-else>{{ item.showValue.content }}</template>
                    </label>
                  </el-col>
                </template>
              </template>
              <template v-if="exhibitInfo && exhibitInfo.questionList">
                <el-col :span="12" class="detail-questionTag" v-for="item in exhibitInfo.questionList" :key="item.id">
                  <span>{{ item.aliasName }}：</span>
                  <template v-for="(aItem, index) in item.answerList">
                    <label class='theme-label' :key="aItem.id" v-if="index < 3">{{ aItem.aliasName }}</label>
                  </template>
                </el-col>
              </template>
            </el-row>
          </div>
          <div class="v-exhibits-base-info" v-if="exhibitInfo.productIntro">
            <div class="baseInfo-title">{{$t('finds.productDetail')}}</div>
            <div class="p">{{ exhibitInfo.productIntro }}</div>
          </div>
        </div>
        <div class="v-exhibits-piic" v-if="exhibitInfo.longImage && exhibitInfo.longImage.length > 0">
          <div  v-for="(item, index) in exhibitInfo.longImage" :key="index">
            <el-image :src="item" lazy></el-image>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getProductDetail, deleteProduct } from '@/api'
import vExhibitsDetail from '@/components/vExhibitsDetail'
import { mapGetters } from 'vuex'
export default {
  //展品详情
  name: 'ExhibitDetail',
  components: {
    vExhibitsDetail
  },
  data() {
    return {
      exhibitInfo: {}
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.getDetail()
    }
  },
   computed: {
    ...mapGetters(['language', 'info', 'isLogin', 'subjectType'])
  },
  methods: {
    productEditor() {
      this.$router.push('/exhibit/' + this.exhibitInfo.id)
    },
    productDel() {
      this.callback({
        type: 'del',
        data: this.exhibitInfo
      })
    },
    getDetail() {
      const loading = this.$loading({
        lock: true
      })
      getProductDetail({
        id: this.$route.params.id,
        showType: 'PRODUCT_DETAILS'
      })
        .then(res => {
          loading.close()
          this.exhibitInfo = res.data.data
          let list = []
          if (this.exhibitInfo.piiic) {
            this.exhibitInfo.piiic.split(',').forEach(element => {
              if (element) {
                list.push(element)
              }
            })
            this.exhibitInfo.longImage = list
          }
        })
        .finally(() => {
          loading.close()
        })
    },
    callback(res) {
      if (res.type == 'editor') {
        this.$router.push(`/exhibit/${res.data.id}`)
      } else if (res.type == 'del') {
        this.$alert(this.$t('Are you sure detele this item?'), this.$t('Confirm'), {
          showCancelButton: true,
          callback: action => {
            if (action === 'confirm') {
              deleteProduct({ id: res.data.id }).then(res => {
                if (res.data.code === 1000) {
                  this.$router.push(`/my-exhibit-list`)
                }
              })
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.v-exhibits-header{
    width:100%;
    .v-detail{
        width:100%;
        padding-left: 15px;
        max-width:$container-width;
        margin:0 auto;
    }
}

.v-exhibits-content{
    width:100%;
    padding: 0 15px;
    max-width:$container-width;
    margin:24px auto;
}

.v-exhibits-content{
    margin: 30px auto;
    width:100%;
    background: $color-white;

    .v-exhibits-base-info {
      position relative;
      padding: 24px 9px;
      max-width: $container-width;
      margin: 0 auto;

      // & + .v-exhibits-base-info{
      //   &:before{
      //     content: '';
      //     position: absolute;
      //     top: 0;
      //     left: 15px;
      //     right: 15px;
      //     height: 1px;
      //     border-top: 1px solid $border-color-e5;
      //   }
      // }
    }

    .baseInfo-title {
      margin-bottom: 15px;
      font-size: 20px;
      font-weight: 600;
      line-height: 28px;
    }
}

.v-exhibits-piic {
    margin: 0 auto;
    margin-bottom: 30px;
    padding: 0 15px;
    max-width: $container-width;
    text-align: center;
}

</style>
